export default {
  appTitle: 'RatesBoard - Local',
  apiUrl: 'https://localhost:8025/api',
  appEnv: 'development',
  useMockServices: false,
};
